import type { ExcelColumn } from '../../../utils/excelExport';
import type { Company, CompanyColumnFilterKey, CompanyColumnFilters } from '../models/types';

export const COMPANY_EXPORT_COLUMNS: ExcelColumn[] = [
  { header: 'Company', key: 'name' },
  { header: 'Country', key: 'country' },
  { header: 'Industry', key: 'industry' },
  { header: 'Type', key: 'type' },
  { header: 'Status', key: 'status' },
  { header: 'Annual Revenue', key: 'revenue' },
  { header: 'Employees', key: 'employees' },
  { header: 'Linked Acquirer', key: 'acquirer' },
  { header: 'Merchants', key: 'merchants' },
];

export const ACCENT_COLORS = [
  '#5c6bc0',
  '#26a69a',
  '#ffa502',
  '#ff6b6b',
  '#a78bfa',
  '#2ed573',
  '#ff9f43',
  '#20c4f4',
];

export const INITIAL_COMPANIES: Company[] = [
  { id: 1, name: 'EuroShop GmbH', legalName: 'EuroShop Handels GmbH', country: 'Germany', industry: 'Retail', type: 'LLC', status: 'Active', revenue: 3200000, employees: 142, taxId: 'DE812345678', incorporatedYear: 2018, contact: 'thomas.r@euroshop.de', merchants: 3, acquirer: 'EuroPay GmbH' },
  { id: 2, name: 'Parisian Goods', legalName: 'Parisian Goods S.A.S.', country: 'France', industry: 'Fashion', type: 'SAS', status: 'Active', revenue: 980000, employees: 34, taxId: 'FR76412345678', incorporatedYear: 2020, contact: 'ceo@parisiangoods.fr', merchants: 1, acquirer: 'Atlantic Finance' },
  { id: 3, name: 'IberTrade S.L.', legalName: 'IberTrade Comercio S.L.', country: 'Spain', industry: 'Wholesale', type: 'SL', status: 'Active', revenue: 5400000, employees: 280, taxId: 'ES-B12345678', incorporatedYear: 2015, contact: 'legal@ibertrade.es', merchants: 4, acquirer: 'IberAcquire S.L.' },
  { id: 4, name: 'NordStyle A/S', legalName: 'NordStyle Retail A/S', country: 'Denmark', industry: 'E-commerce', type: 'A/S', status: 'Active', revenue: 1750000, employees: 68, taxId: 'DK12345678', incorporatedYear: 2019, contact: 'billing@nordstyle.dk', merchants: 2, acquirer: 'NordPay A/S' },
  { id: 5, name: 'AlphaRemit Ltd', legalName: 'AlphaRemit Financial Ltd', country: 'Ireland', industry: 'Fintech', type: 'Ltd', status: 'Pending', revenue: 420000, employees: 12, taxId: 'IE1234567A', incorporatedYear: 2025, contact: 'ceo@alpharemit.ie', merchants: 1, acquirer: 'AlphaRemit Ltd' },
  { id: 6, name: 'Balkara Retail', legalName: 'Balkara Retail d.o.o.', country: 'Croatia', industry: 'Retail', type: 'DOO', status: 'Active', revenue: 870000, employees: 55, taxId: 'HR12345678901', incorporatedYear: 2017, contact: 'finance@balkara.hr', merchants: 1, acquirer: 'EuroPay GmbH' },
  { id: 7, name: 'VistaCommerce', legalName: 'VistaCommerce Lda.', country: 'Portugal', industry: 'Travel', type: 'Lda', status: 'Suspended', revenue: 0, employees: 22, taxId: 'PT123456789', incorporatedYear: 2021, contact: 'ops@vistacommerce.pt', merchants: 0, acquirer: '—' },
  { id: 8, name: 'HellasPay S.A.', legalName: 'HellasPay Payment Services S.A.', country: 'Greece', industry: 'Fintech', type: 'SA', status: 'Active', revenue: 1200000, employees: 41, taxId: 'EL123456789', incorporatedYear: 2022, contact: 'ops@hellaspay.gr', merchants: 2, acquirer: 'EuroPay GmbH' },
];

export const EMPTY_COMPANY_COLUMN_FILTERS: CompanyColumnFilters = {
  country: null,
  industry: null,
  status: null,
};

export const COMPANY_COLUMN_FILTER_LABELS: Record<CompanyColumnFilterKey, string> = {
  country: 'Country',
  industry: 'Industry',
  status: 'Status',
};
